/*
 * @Author: chen_yong
 * @Date: 2020-04-21 20:29:08
 * @Version: 1.0.0
 * @LastEditTime: 2021-02-19 11:26:09
 * @Description: 
 */
/**
 * @file Axios的Vue插件（添加全局请求/响应拦截器）
 */

// https://github.com/mzabriskie/axios
import axios from 'axios'

const location = global.location
const localStorage = global.localStorage
const baseUrl = 'https://manage.zhhlxh.org.cn/mapi';
// const baseUrl = 'http://192.168.3.38:15588/mapi';

axios.defaults.baseURL = baseUrl;

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('X_TOKEN');
  if (token) {
    config.headers.token = `${token}`;
  }
  return config;
})

axios.interceptors.response.use((response) => {

  // 下载文件
  if (response.request.responseType === 'blob') {
    return response;
  }

  const data = response.data;

  switch (data.code) {
    case 0:
    case '0':
      return data;
    case '99':
    case 99:
      return location.href = '/';
    default:
  }

  const err = new Error(data.msg)

  err.data = data
  err.response = response

  throw err
}, (err) => {
  if (err && err.response) {
    switch (err.response.status) {
      case 401:
        err.message = '请登录'
        break

      case 404:
        err.message = `请求地址出错:`
        break

      case 500:
      case 503:
        err.message = '服务器错误'
        break

      case 502:
        err.message = '请求数据超时，请刷新页面重试'
        break

      default:
    }
  }

  return Promise.reject(err)
})

axios.install = (Vue) => {
  Vue.prototype.$axios = axios
}

export default axios



// WEBPACK FOOTER //
// ./src/plugins/axios.js